export enum DashboardExpiringSamplesColumnEnum {
    SAMPLE,
    LAST_USED,
    STORAGE_DATE_END,
}

export const dashboardExpiringSamplesTableColumnText: Record<DashboardExpiringSamplesColumnEnum, string> = {
    [DashboardExpiringSamplesColumnEnum.SAMPLE]: 'inventory.samples.list.table.column.sampleName',
    [DashboardExpiringSamplesColumnEnum.LAST_USED]: 'inventory.samples.list.table.column.lastUsed',
    [DashboardExpiringSamplesColumnEnum.STORAGE_DATE_END]: 'inventory.samples.list.table.column.storageDateEnd',
};
